/* eslint-disable react/prop-types */
import Tooltip from 'antd/lib/tooltip/index.js';
import {isVacation} from './../../../utils/calendarUtility';

const ProductionDayEvents = ({dayData}) => {

    const substract = dayData?.deals?.length >= 3 ? 3 : dayData?.deals?.length;

    return (
        <div className='flex-1 h-full flex flex-col justify-between gap-0.5'>
            <div>
                {dayData?.deals.map((event, index) => {
                    const dotColor = isVacation(event.short_name) ? 'bg-[#646464]' : 'background-gradient';

                    if (index < 3) {
                        return (
                            <div className="flex flex-row items-center mb-1" key={event.id}>
                                <div className={`${dotColor} flex justify-center items-center w-2 h-2 mr-1.5 rounded-full`}>
                                    <div className={`w-1 h-1 ${event.is_forecasted ? "bg-white" : "bg-transparent"} rounded-full`}/>
                                </div>
                                <Tooltip title={event.short_name}>
                                    <p className="text-xs w-full overflow-x-hidden whitespace-nowrap">
                                        {event.short_name}
                                    </p>
                                </Tooltip>
                            </div>
                        );
                    }
                })}
            </div>

            <div className="flex items-center justify-between w-full h-5">
                {
                    (dayData?.produced_days) &&
                        <p className="text-left text-gradient w-fit">
                            {dayData?.produced_days.toFixed(2)}j
                        </p>
                }
                {
                    dayData?.count > 3 &&
                        <p className="flex items-center justify-center h-5 min-w-[20px] w-fit text-[9px] py-[1px] px-1 font-bold leading-none text-left text-white rounded-full roboto bg-[#212121]">
                            +{dayData?.count - substract}
                        </p>
                }
            </div>
        </div>
    );
};

export default ProductionDayEvents;
